import React, { useState } from 'react'
import Layout from '../components/layout'
import styled from 'styled-components'

const Div = styled.div`

    background: #f7f8fa;
    min-height: 100%;


    .faq-container {
        max-width: 1000px;
        margin: 0 auto;

        padding: 60px 25px 80px;
    }


    /* ==============================
       HEADER
    ============================== */

    .faq-header {
        text-align: center;
        margin-bottom: 45px;
    }

    .faq-eyebrow {
        display: block;

        margin-bottom: 8px;

        color: #E85A20;

        font-size: 12px;
        font-weight: 700;

        letter-spacing: 3px;
        text-transform: uppercase;
    }

    .faq-header h2 {
        margin: 0;

        color: #102B50;

        font-size: 40px;
        font-weight: 700;
    }

    .faq-line {
        width: 50px;
        height: 4px;

        margin: 15px auto;

        background: #E85A20;

        border-radius: 5px;
    }

    .faq-header p {
        max-width: 600px;

        margin: 0 auto;

        color: #687586;

        font-size: 15px;
        line-height: 1.6;
    }


    /* ==============================
       LISTA
    ============================== */

    .questions {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }


    /* ==============================
       ITEM
    ============================== */

    .question {
        overflow: hidden;

        background: #ffffff;

        border: 1px solid #e2e7ec;
        border-radius: 7px;

        box-shadow: 0 3px 12px rgba(20, 40, 60, 0.04);

        transition: all .2s ease;
    }

    .question:hover {
        border-color: #ccd5dd;

        box-shadow: 0 5px 18px rgba(20, 40, 60, 0.07);
    }


    /* ==============================
       BOTÓN PREGUNTA
    ============================== */

    .question-button {
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 20px 24px;

        border: none;

        background: #ffffff;

        color: #102B50;

        text-align: left;

        font-size: 16px;
        font-weight: 600;

        cursor: pointer;

        transition: all .2s ease;
    }

    .question-button:hover {
        color: #E85A20;
    }


    .question-button.active {
        color: #E85A20;
    }


    /* ==============================
       ICONO
    ============================== */

    .question-icon {
        flex-shrink: 0;

        width: 28px;
        height: 28px;

        display: flex;
        align-items: center;
        justify-content: center;

        margin-left: 20px;

        border: 1px solid #d9dfe5;
        border-radius: 50%;

        color: #687586;

        font-size: 18px;
        font-weight: 400;

        transition: all .2s ease;
    }

    .question-button:hover .question-icon,
    .question-button.active .question-icon {
        border-color: #E85A20;

        background: #E85A20;

        color: #ffffff;
    }


    /* ==============================
       RESPUESTA
    ============================== */

    .answer {
        padding: 0 24px 23px;

        color: #526274;

        font-size: 14px;
        line-height: 1.7;
    }

    .answer p {
        margin: 0;
    }


    /* ==============================
       MOBILE
    ============================== */

    @media screen and (max-width: 768px) {

        .faq-container {
            padding: 45px 15px 60px;
        }

        .faq-header {
            margin-bottom: 30px;
        }

        .faq-header h2 {
            font-size: 32px;
        }

        .question-button {
            padding: 17px 18px;

            font-size: 15px;
        }

        .answer {
            padding: 0 18px 20px;

            font-size: 14px;
        }

        .question-icon {
            width: 25px;
            height: 25px;

            margin-left: 12px;
        }

    }

`


const faqData = [

    {
        question: '¿Cómo denuncio un siniestro?',
        answer: 'Deberás solicitar en nuestras oficinas el formulario de denuncia correspondiente a la cobertura que deseás denunciar, o bien, descargarlo de esta página web, y presentarlo completo y firmado junto con toda la documentación que se detalla en el mismo.'
    },

    {
        question: '¿En qué consiste un seguro de Vida?',
        answer: 'El seguro de Vida funciona como un resarcimiento económico en caso de fallecimiento del asegurado para los beneficiarios designados o herederos legales del mismo.'
    },

    {
        question: '¿Quién cobra un seguro de vida?',
        answer: 'Si el asegurado firma una manifestación escrita, lo harán los beneficiarios que designe en ella; caso contrario, cobrarán los herederos legales.'
    },

    {
        question: '¿A quién puedo designar como beneficiario? ¿Puedo designar a más de una persona?',
        answer: 'Podés designar como beneficiario de tu seguro a la/s persona/s que elijas. También podés elegir la cantidad de beneficiarios que quieras y podés modificarlos cuando consideres necesario. En el caso de no haber designado ningún beneficiario, los mismos serán los herederos legales.'
    },

    {
        question: '¿Puedo cambiar los beneficiarios designados? ¿Cómo?',
        answer: 'Sí, podés. Tenés que firmar el formulario de Designación de Beneficiarios correspondiente, el cual te facilitará tu empleador.'
    },

    {
        question: '¿En qué consiste la cobertura de Accidente o Enfermedad Inculpable?',
        answer: 'Esta cobertura se basa en el Art. 208 de la Ley de Contrato de Trabajo, el cual establece que el trabajador tendrá derecho a percibir su remuneración cuando se encuentre de licencia por accidente o enfermedad inculpable durante los períodos dispuestos conforme a su antigüedad y carga de familia. Tenés que tener en cuenta que para cada supuesto el empleador tendrá las siguientes franquicias a su exclusivo cargo: (I) un mes por cada contingencia en los casos en que la legislación laboral contemple el pago de remuneraciones por un periodo de hasta tres meses, (II) dos y tres meses por cada contingencia, según el caso, para los supuestos en que la legislación laboral contemple el pago de remuneraciones por un periodo de hasta seis y doce meses respectivamente. Los salarios que forman parte de esta cobertura serán abonados por el empleador y luego reintegrados por la aseguradora.'
    }

]


export default function About() {

    const [activeQuestion, setActiveQuestion] = useState(null)


    const toggleQuestion = (index) => {

        if (activeQuestion === index) {
            setActiveQuestion(null)
        } else {
            setActiveQuestion(index)
        }

    }


    return (

        <Layout>

            <Div>

                <div className="faq-container">


                    {/* HEADER */}

                    <div className="faq-header">

                        <span className="faq-eyebrow">
                            Ayuda y consultas
                        </span>

                        <h2>
                            Preguntas frecuentes
                        </h2>

                        <div className="faq-line"></div>

                        <p>
                            Encontrá respuestas a las consultas
                            más habituales sobre nuestros seguros.
                        </p>

                    </div>


                    {/* PREGUNTAS */}

                    <div className="questions">

                        {faqData.map((item, index) => {

                            const isActive = activeQuestion === index

                            return (

                                <div
                                    className="question"
                                    key={index}
                                >

                                    <button
                                        className={`question-button ${isActive ? 'active' : ''}`}
                                        onClick={() => toggleQuestion(index)}
                                    >

                                        <span>
                                            {item.question}
                                        </span>


                                        <span className="question-icon">

                                            {isActive ? '−' : '+'}

                                        </span>

                                    </button>


                                    {isActive && (

                                        <div className="answer">

                                            <p>
                                                {item.answer}
                                            </p>

                                        </div>

                                    )}

                                </div>

                            )

                        })}

                    </div>

                </div>

            </Div>

        </Layout>

    )

}


// import React from 'react'
// import Layout from '../components/layout'
// import styled from 'styled-components'


// const Div = styled.div`

//     .questions div {
//         padding: 20px 20px;
//         background: #009ade;
//         border-radius: 10px;
//         box-shadow: 1px 4px 5px #a5cbec;
//         color: white;
//         margin: 15px 0;
//         transition: all 0.5s ease-in-out;
//     }

//     .questions div:hover {
//         transform: scale(1.05);
//     }

//     @media screen and (max-width: 996px) {
//         .questions div:hover {
//             transform: scale(1);
//         }
//     }

// `

// export default function About()  {

//     return(
//         <Layout>
//             <Div className="container-xl p-0">

//                 <div>


//                     <h3 className="pt-3 px-2 text-lg-left text-center text-company"><b>Preguntas Frecuentes</b></h3>

//                     <hr />

//                     <div className="questions pb-3 px-lg-0 px-2">

//                         <div>
//                             <h5><strong>¿Cómo denuncio un siniestro?</strong></h5>
//                             <p>Deberás solicitar en nuestras oficinas el formulario de denuncia correspondiente a la cobertura que deseás denunciar, o bien, descargarlo de esta página web, y presentarlo completo y firmado junto con toda la documentación que se detalla en el mismo.</p>
//                         </div>
//                         <div>
//                             <h5><strong>¿En qué consiste un seguro de Vida?</strong></h5>
//                             <p>El seguro de Vida funciona como un resarcimiento económico en caso de fallecimiento del asegurado para los beneficiarios designados o herederos legales del mismo.</p>
//                         </div>
//                         <div>
//                             <h5><strong>¿Quién cobra un seguro de vida?</strong></h5>
//                             <p>Si el asegurado firma una manifestación escrita, lo harán los beneficiarios que designe en ella; caso contrario, cobrarán los herederos legales.</p>
//                         </div>
//                         <div>
//                             <h5><strong>¿A quién puedo designar como beneficiario? ¿Puedo designar a más de una persona?</strong></h5>
//                             <p>Podés designar como beneficiario de tu seguro a la/s persona/s que elijas. También podés elegir la cantidad de beneficiarios que quieras y podés modificarlos cuando consideres necesario. En el caso de no haber designado ningún beneficiario, los mismos serán los herederos legales.</p>
//                         </div>
//                         <div>
//                             <h5><strong>¿Puedo cambiar los beneficiarios designados? ¿Cómo?</strong></h5>
//                             <p>Si, podés. Tenés que firmar el formulario de Designación de Beneficiarios correspondiente, el cuál te facilitará tu empleador.</p>
//                         </div>
//                         <div>
//                             <h5><strong>¿En qué consiste la cobertura de Accidente o Enfermedad Inculpable?</strong></h5>
//                             <p>Esta cobertura se basa en el Art. 208 de la ley de contrato de trabajo, el cual establece que el trabajador tendrá derecho a percibir su remuneración cuando se encuentre de licencia por accidente o enfermedad inculpable durante los períodos dispuestos conforme a su antigüedad y carga de familia. Tenés que tener en cuenta que para cada supuesto el empleador tendrá las siguientes franquicias a su exclusivo cargo: (I) un mes por cada contingencia en los casos en que la legislación laboral contemple el pago de remuneraciones por un periodo de hasta tres meses, (II) dos y tres meses por cada contingencia, según el caso, para los supuestos en que la legislación laboral contemple el pago de remuneraciones por un periodo de hasta seis y doce meses respectivamente. Los salarios que forman parte de esta cobertura serán abonados por el empleador y luego reintegrados por la aseguradora.</p>
//                         </div>

//                     </div>


//                 </div>

//             </Div>
//         </Layout>

//     )

// }